import { Meeting } from "@kalyzee/kast-web-sdk/websocket";
import React, { ForwardedRef } from "react";

import { MeetingSessionOvenMediaReceiverManagerBaseData } from "@kalyzee/kast-web-sdk";
import { OvenMediaReceiverWebRTCSession } from "@kalyzee/kast-web-sdk/webrtc";
import { GroupWithRotatingSessions } from "../../../hooks/meetingMessagingBridge";
import { ScreenParams } from "../../../hooks/screen";
import { SlaveCarouselData } from "../../../pages/slave/meeting/meeting";
import { SecondaryScreenGrid } from "../grid/Grid";
import { SecondaryScreenGroup } from "../group/Group";
import styles from "./Session.module.css";

export interface SecondaryScreenSessionsProps {
  meeting: Meeting;
  videoSessions: OvenMediaReceiverWebRTCSession<MeetingSessionOvenMediaReceiverManagerBaseData<any>>[];
  screenParams: ScreenParams;
  carouselData: SlaveCarouselData;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export interface SecondaryScreenSessionsRef {}

export const SecondaryScreenSessions = React.forwardRef(
  (
    { meeting, videoSessions, screenParams, carouselData, className, style }: SecondaryScreenSessionsProps,
    forwardRef: ForwardedRef<SecondaryScreenSessionsRef>
  ) => {
    // Verifying expiration on slave side
    const groupSlots = screenParams.index === 1 || screenParams.index === 2 ? 2 : 3;

    const renderGroups = (groupNumber: number = 2) => {
      if (carouselData.data.mode !== "groups") return null; // impossible
      const groupCarouselData = carouselData as SlaveCarouselData & { data: { mode: "groups" } };
      const groups: (GroupWithRotatingSessions | null)[] = groupCarouselData.data.groups.slice(0, groupNumber);
      for (let i = groups.length; i < groupNumber; i++) {
        groups.push(null);
      }
      return (
        <div className={styles.allGroupsContainer}>
          {groups.map((group, index) => {
            if (!group) return <div key={`group_null_${index}`} className={styles.groupContainer} style={{ background: "black" }} />;
            return <SecondaryScreenGroup meeting={meeting} videoSessions={videoSessions} groupWithRotatingSessions={group} />;
          })}
        </div>
      );
    };

    const renderGrid = () => {
      const sesssionsCarouselData = carouselData as SlaveCarouselData & { data: { mode: "sessions" } };
      return (
        <SecondaryScreenGrid
          meeting={meeting}
          sessions={sesssionsCarouselData.data.sessions}
          videoSessions={videoSessions}
          grid={{
            row: screenParams.rows,
            column: screenParams.columns,
            gap: 8,
            autoAdjust: false
          }}
        />
      );
    };

    // ---------------------------------------------------------------------- //
    // ---------------------------  EFFECTS ----------------------------- //
    // ---------------------------------------------------------------------- //

    // ---------------------------------------------------------------------- //
    // ---------------------------  RENDER ----------------------------- //
    // ---------------------------------------------------------------------- //

    const classes = [styles.column];
    if (className) classes.push(className);
    return (
      <div className={classes.join(" ")} style={style}>
        {carouselData.data.mode === "groups" ? renderGroups(groupSlots) : renderGrid()}
        {carouselData.pageCount > 1 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "20px",
              padding: "10px 10px",
              backgroundColor: "#88888866",
              margin: "10px 0px",
              gap: "5px",
            }}
          >
            {new Array(carouselData.pageCount).fill(0).map((_, i) => {
              return (
                <div
                  key={`page_${i}`}
                  style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: i === carouselData.page ? "#CCCCCCDD" : "#AAAAAA44" }}
                />
              );
            })}
          </div>
        ) : null}
      </div>
    );
  }
);
